import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocalGroceryStoreOutlinedIcon from "@mui/icons-material/LocalGroceryStoreOutlined";
import { Badge } from "@mui/material";
import { useSelector } from "react-redux";
const Navbar = () => {
  const items = useSelector((state) => state.cart);
  return (
    <div className="Navbar">
      <div>
        <span
          style={{
            display: "flex",
            flexDirection: "row",
            backgroundColor: "red",
            fontSize: "30px",
            color: "black",
          }}
        >
          <StorefrontIcon style={{ fontSize: "30px" }} />
        </span>
        <span className="head">eShop.here</span>
        <Link to="/" className="nav_link">
          Home{" "}
        </Link>
        <Link to="/Cart" className="nav_link">
          Cart
        </Link>
      </div>
      <span>
        <Badge color="primary" badgeContent={items.length}>
          <LocalGroceryStoreOutlinedIcon style={{ fontSize: "30px" }} />
        </Badge>
      </span>
    </div>
  );
};

export default Navbar;
